import React from 'react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';

import Loading from './Loading';

const CardContainer = ({ isReady, title, children }) => (
  <>
    {isReady && (
      <h1 className='title'>{title}</h1>
    )}
    {!isReady && <Loading />}
    {isReady && (
      <Card style={{ flex: 1 }}>
        <CardBody>
          {children}
        </CardBody>
      </Card>
    )}
  </>
);

CardContainer.propTypes = {
  isReady: PropTypes.bool,
  title: PropTypes.string
};

CardContainer.defaultProps = {
  isReady: true,
  title: ''
};

export default CardContainer;
